// extracted by mini-css-extract-plugin
export default {"imageWrapper":"xN-z","twoColumnImage":"yN-z"};